export { default } from './Column'


// WEBPACK FOOTER //
// ./src/components/Column/index.js